import React, { useContext } from "react";
import InputsContext from "../contexts/InputsContext";
import ReturnButton from "../steps/ReturnButton";

const NewQuoteNavbar = () => {
  const { inputs, setInputs } = useContext(InputsContext);

  const progressionWidth = () => {
    const numberOfSteps = inputs.steps.length + 1;
    const numberOfStepsComplete = inputs.currentIndex;
    return Math.round((numberOfStepsComplete / numberOfSteps) * 100);
  };

  return (
    <div>
      <div className="text-xl font-semibold border-b border-blueGray-200">
        <div className="container mx-auto px-6 md:max-w-screen-xl flex items-center justify-between h-16">
          <span className="w-40 flex items-center justify-start">
            {inputs.currentIndex === 0 ? (
              <a href="/" className="text-blueGray-500">
                Accueil
              </a>
            ) : (
              <ReturnButton />
            )}
          </span>
          <span className="w-40 flex items-center justify-end">
            <img
              src="https://res.cloudinary.com/new-app/image/upload/v1626349890/logo-orange.png"
              alt="logo"
            />
          </span>
        </div>
      </div>
      <div className="w-1/3 h-2 bg-blueGray-200 relative rounded-xl mx-auto my-10">
        <div
          className="bg-cyan-500 absolute z-10 rounded-xl h-full"
          style={{ width: `${progressionWidth()}%` }}
        ></div>
      </div>
    </div>
  );
};

export default NewQuoteNavbar;
